import { ColoredBadge as UiColoredBadge, styled } from "@l2r-front/l2r-ui"

export const ColoredBadge = styled(UiColoredBadge)(({ theme, borderColor }) => ({
    border: `1px solid ${borderColor}`,
    padding: theme.spacing(1.5),
    width: 50,
}))